import { createContext, useContext, useState, useEffect } from "react";
import { MetricMetadata } from "../services/types";
import { fetchMetricMetadataByOrg, orgId } from "../utils/dashboardUtils";

const MetadataContext = createContext<MetricMetadata[] | null>(null);

export const MetadataProvider = ({ children }: { children: React.ReactNode }) => {
  const [metadata, setMetadata] = useState<MetricMetadata[] | null>(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      if (!orgId) return;
      try {
        const response = await fetchMetricMetadataByOrg(orgId);
        console.log('fetched metadata from context:', response.data);
        setMetadata(response.data);
      } catch (error) {
        console.error("Error fetching metric metadata:", error);
      }
    };
    fetchMetadata();
  }, [orgId]);

  return <MetadataContext.Provider value={metadata}>{children}</MetadataContext.Provider>;
};

export const useMetadata = () => useContext(MetadataContext);